import { render } from "./ProgressBar.vue?vue&type=template&id=325b5d64&scoped=true&lang=pug"
import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=325b5d64&lang=sass&scoped=true"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325b5d64"]])

export default __exports__